import React from "react";
import { formatRupiah } from "../../../../../utils/helper";
import { TicketDiscountIcon } from "../../../../../utils/svg";
import TooltipInfo from "../../../../../components/TooltipInfo";

const PaymentSummaryOption = ({
  paymentSummary = {},
  tooltipOtherFee = {},
  totalNominalB2BVoucher = 0,
  tooltipVoucherList = [],
  maxNominalVoucher = 0,
  totalPriceB2BVoucher = 0,
  strikeOutTotalPayment = 0,
  values = {}
}) => {
  return (
    <div className="mx-4 mt-4 mb-28">
      <div className="text-gray-900 text-sm font-semibold">
        Rincian Pembayaran
      </div>
      <div className="mt-4 border-solid border-1 border-gray-300 rounded-lg px-4 py-2.5">
        <div className={`flex justify-between items-center`}>
          <div className="text-gray-900 text-xs font-normal">F&B Price</div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-700 pl-2">
              {formatRupiah(paymentSummary?.subTotal || 0)}
            </div>
          </div>
        </div>
        <div
          className={`${!paymentSummary?.tax ? "hidden" : "flex"} justify-between items-center mt-1`}
        >
          <div className="text-gray-900 text-xs font-normal">Tax</div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-700 pl-2">
              {formatRupiah(paymentSummary?.tax)}
            </div>
          </div>
        </div>
        <div
          className={`${!paymentSummary?.pb1 ? "hidden" : "flex"} justify-between items-center mt-1`}
        >
          <div className="text-gray-900 text-xs font-normal">PB1</div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-700 pl-2">
              {formatRupiah(paymentSummary?.pb1)}
            </div>
          </div>
        </div>
        <div
          className={`${!paymentSummary?.deliveryFee || values?.orderType === "pickup" ? "hidden" : "flex"} justify-between items-center mt-1`}
        >
          <div className="text-gray-900 text-xs font-normal">Delivery</div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-700 pl-2">
              {formatRupiah(paymentSummary?.deliveryFee || 0)}
            </div>
          </div>
        </div>
        <div
          className={`${!paymentSummary?.otherFee ? "hidden" : "flex"} justify-between items-center mt-1`}
        >
          <div className="text-gray-900 text-xs font-normal flex items-center">
            Biaya lainnya
            <TooltipInfo
              title="Apa saja biaya di dalam nya?"
              items={tooltipOtherFee}
              id="summary_tooltip_other_fees"
              btn_id="summary_tooltip_other_fees_gotit"
            />
          </div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-700 pl-2">
              {formatRupiah(paymentSummary?.otherFee || 0)}
            </div>
          </div>
        </div>
        <div
          className={`${!totalNominalB2BVoucher ? "hidden" : "flex"} justify-between items-center mt-1`}
        >
          <div className="text-gray-900 text-xs font-normal">Beli Voucher</div>
          <div className="text-xs font-normal flex">
            <div className="text-gray-400 font-thin line-through">
              {formatRupiah(totalNominalB2BVoucher)}
            </div>
            <div className="text-gray-700 pl-2">
              {formatRupiah(totalPriceB2BVoucher)}
            </div>
          </div>
        </div>
        <div
          className={`${!paymentSummary?.fixTotalVoucherNominal ? "hidden" : "flex"} justify-between items-center mt-2`}
        >
          <div className="text-gray-900 text-xs font-normal flex items-center">
            <TicketDiscountIcon className="h-6 w-6 mr-1" />
            Voucher Terpakai
            <TooltipInfo
              title="Voucher Terpakai"
              items={tooltipVoucherList}
              id="summary_tooltip_voucher_applied"
              btn_id="summary_tooltip_voucher_applied_gotit"
            />
          </div>
          <div className="text-xs font-normal flex">
            <div className="text-[var(--rose-violet)] pl-2">
              -{formatRupiah(paymentSummary?.fixTotalVoucherNominal || 0)}
            </div>
          </div>
        </div>

        {paymentSummary?.strikeDiscount > 0 && (
          <div className="mt-2 border-b border-gray-200 pb-2">
            <div className="flex items-center gap-2 rounded-xl border border-green-200 bg-green-50 px-3 py-2">
              <div className="text-green-500 text-sm">
                🎉
              </div>

              <div className="text-green-600 text-xs font-normal">
                Kamu berhasil hemat{' '}
                <span className="font-semibold">
                  {formatRupiah(
                    paymentSummary?.strikeDiscount
                  )}
                </span>{' '}
                pada pesanan ini!
              </div>
            </div>
          </div>
        )}

        <div className="border-b-1 border-solid pb-2 border-gray-300" />
        <div className="flex justify-between items-center mt-2">
          <div className="text-gray-900 text-sm font-extrabold items-center">
            Total Pembayaran
          </div>
          <div className="text-sm font-extrabold flex">
            <div
              className={`${!maxNominalVoucher && "hidden"} text-gray-400 font-thin line-through`}
            >
              {formatRupiah(strikeOutTotalPayment)}
            </div>
            <div className="text-gray-900 pl-2">
              {formatRupiah(paymentSummary?.totalPayment || 0)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummaryOption;
